import { gql } from "graphql-request";
export const REVIEW_GET_DOMAIN_OFFER_QUERY = gql`
    query getReviewDomainOffers($categoryId: Int, $domainId: Int) {
        allDomainOffers(domainId: $domainId, categoryId: $categoryId) {
            offers(orderByDesc: weight, isDeleted: false, isActive: true) {
                slug
                translations {
                    key
                    value
                    language
                }
                logo {
                    fullPath
                }
            }
        }
    }
`;
